import { Box, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useEffect, useState } from "react";
import LocationsToDisplay from "./LocationsToDisplay";
import SidebarBand from "./SidebarBand";

function BandsList({
  bands,
  selectedRegion,
  setSelectedBand,
  setSidebarOpen,
  setShowBandDetails,
  scrollableContainerRef,
}) {
  const [chunk, setChunk] = useState(50);

  useEffect(() => {
    if (scrollableContainerRef) {
      scrollableContainerRef.current.addEventListener("scroll", () => {
        if (
          scrollableContainerRef.current.scrollTop +
            scrollableContainerRef.current.clientHeight >=
          scrollableContainerRef.current.scrollHeight
        ) {
          setChunk((prevChunk) => prevChunk + 50);
        }
      });
    }
  }, [chunk, scrollableContainerRef]);

  return (
    <Paper sx={bandsWrapperStyles} variant="locations-wrapper">
      <Box>
        {bands?.slice(0, chunk).map((band) => (
          <Box key={band.id}>
            <SidebarBand
              band={band}
              setShowBandDetails={setShowBandDetails}
              setSidebarOpen={setSidebarOpen}
              setSelectedBand={setSelectedBand}
            >
              {band.name}
            </SidebarBand>
          </Box>
        ))}
      </Box>

      <LocationsToDisplay>
        <Typography
          sx={{ fontSize: "0.875rem !important", textTransform: "uppercase" }}
        >
          Gesamt
        </Typography>
        <Typography>
          {selectedRegion
            ? selectedRegion.region.popboard_bands?.length
            : bands.length}{" "}
          Ergebnisse
        </Typography>
      </LocationsToDisplay>
    </Paper>
  );
}

export default BandsList;

const bandsWrapperStyles = {
  backgroundColor: grey[900],
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};
